<template>
    <div>
        <!-- 推荐知识 -->
        <show-knowledge-mes :hotFAQ='hotFAQ'></show-knowledge-mes>
    </div>
</template>

<script>
    import showKnowledgeMes from "../showKnowledgeMes.vue"
    export default {
        props:{
            hotFAQ:Array
        },
        components: { showKnowledgeMes },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
